import { render, staticRenderFns } from "./table-group.vue?vue&type=template&id=6c86e6d7&scoped=true&"
import script from "./table-group.vue?vue&type=script&lang=js&"
export * from "./table-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c86e6d7",
  null
  
)

export default component.exports